import React, { useState } from 'react';
import axios from './AxiosConfig';
import styles from './styles/completeConfig.module.css';
import OtpInput from './OtpInput';

const CompleteConfig = ({ onNextStep }) => {
    const [otp, setOtp] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (otp.length < 6) {
            setError('Inserisci un codice OTP completo.');
            return;
        }

        try {
            const response = await axios.post('/api/complete_config/', { otp });
            console.log("Response data:", response.data);
            if (response.status === 200) {
                console.log("Response data:", response.data);
                onNextStep('config_success');
                return
            } else {
                setError('Codice OTP non valido.');
                setOtp(''); 
                return
            }
        } catch (error) {
            console.error("Errore durante la verifica dell'OTP:", error);
            setError("Errore durante la verifica dell'OTP.");
            setOtp(''); 
        }
    };

    const handleOtpChange = (value) => {
        setOtp(value);
        if (error) setError('');
    };
    
    // 🔹 Se vuoi pulire anche cliccando nell'area (focus)
    const handleFieldFocus = () => {
        if (error) setError('');
    };
    return (
        <div className={`col-4 ${styles.lato_form}`}>
            <div className={`p-4 border rounded ${styles.containerloginform}`}>
                <div className={`p-4 border rounded ${styles.containerTesto}`}>
                    <h4>Completa la configurazione</h4>
                </div>
                <div className={styles.messaggioErrore}>
                    {error && <div className="alert alert-danger">{error}</div>}
                    {message && <div className="alert alert-success">{message}</div>}
                </div>
                <div className={styles.login_form}>
                    <form onSubmit={handleSubmit}>
                        <div className={`p-4 border rounded ${styles.Testo2}`}>
                            <label htmlFor="otpCode">Inserisci l'OTP monouso per confermare la configurazione:</label>
                        </div>
                        <div className={`p-4 border rounded ${styles.inputOtp}`}>
                            <OtpInput length={6} onOtpChange={handleOtpChange}
                            onClick={handleFieldFocus} />
                        </div>
                        <button type="submit" className={styles.btnVerify}>
                            Verifica
                        </button>
                    </form>
                    <div className={styles.backup_Option}>
                        <p>Non hai scansionato il QR code? Torna indietro</p>
                        <button
                            onClick={() => onNextStep('generate_qr')}
                            className={`btn btn-link ${styles.btnLink}`}
                        >
                            Torna al QR
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompleteConfig;
